import Status404 from './status-404/Status404';
import Start from './start/Start';
import NoScript from './no-script/NoScript';
import PrivacyPolicy from './privacy-policy/PrivacyPolicy';
import CookiesPolicy from './cookies-policy/CookiesPolicy';
import OrderStatus from './OrderStatus/OrderStatus';
import Activities from './activities/Activities';
import CartManagement from './cart/CartManagement';
import CartData from './cart/CartData';
import PaymentStatus from './payment/PaymentStatus';
import CartSummary from './cart/cart-summary/CartSummary';
import Attractions from './activities/Attractions';

const Pages = {
  Start,
  Status404,
  NoScript,
  PrivacyPolicy,
  CookiesPolicy,
  OrderStatus,
  Activities,
  CartManagement,
  CartData,
  PaymentStatus,
  CartSummary,
  Attractions,
};

export default Pages;
